import React from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonIcon, IonLabel, IonContent, IonItem, IonButtons, IonBackButton } from '@ionic/react'
import { calendar, settings } from 'ionicons/icons'
import GST from '../pages/Settings/GST'
import BackupRestore from '../pages/Settings/BackupRestore'

const Settings = () => {

    const showHide = (component) => {
        let el = document.getElementById(component)
        el.classList.toggle('ion-hide')
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Settings</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                <IonItem style={{ cursor: 'pointer' }} onClick={() => showHide('gst')}>
                    <IonIcon icon={calendar} slot='start'></IonIcon>
                    <IonLabel>GST</IonLabel>
                </IonItem>
                <div id='gst' className='ion-hide'>
                    <GST />
                </div>
                <IonItem style={{ cursor: 'pointer' }} onClick={() => showHide('backup')}>
                    <IonIcon icon={settings} slot='start'></IonIcon>
                    <IonLabel>Backup Restore</IonLabel>
                </IonItem>
                <div id='backup' className='ion-hide'>
                    <BackupRestore />
                </div>

            </IonContent>
        </IonPage>
    )
}

export default Settings
